import { render, staticRenderFns } from "./twentyFourHours.vue?vue&type=template&id=709b8d24&scoped=true"
import script from "./twentyFourHours.vue?vue&type=script&lang=js"
export * from "./twentyFourHours.vue?vue&type=script&lang=js"
import style0 from "./twentyFourHours.vue?vue&type=style&index=0&id=709b8d24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b8d24",
  null
  
)

export default component.exports